<div class="form-container">
  <h1 class="ion-text-center ion-margin-bottom">
    Solicita tus facturas
  </h1>
  <div class="ion-margin-top ion-padding-top">
    <app-form [questions]="requestBillsQuestions" (submit)="requestBills()"></app-form>
  </div>

  <ion-grid>
    <ion-row *ngIf="!loading">
      <ion-col size="8" sizeMd="6" style="margin: auto;">
        <ion-button expand="block" class="ion-text-wrap" fill="clear" (click)="goBack()">
          Volver
        </ion-button>
      </ion-col>
      <ion-col size="8" sizeMd="6" style="margin: auto;">
        <ion-button expand="block" class="ion-text-wrap" (click)="requestBills()">
          Solicitar
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="loading">
      <ion-col size="8" sizeMd="6" class="ion-text-center" style="margin: auto;">
        <ion-spinner name="crescent"></ion-spinner>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>